export const trimImageURI = (imageString: any) => {
    if (
        imageString?.toString().substring(0, 25).split('/')[1].split(';')[0] === 'png' ||
        imageString?.toString().substring(0, 25).split('/')[1].split(';')[0] === 'jpg' ||
        imageString?.toString().substring(0, 25).split('/')[1].split(';')[0] === 'pdf'
    ) {
        return imageString?.substring(22)
    }
    else if (
        imageString?.toString().substring(0, 25).split('/')[1].split(';')[0] === 'jpeg'
    ) {
        return imageString?.substring(23)
    }
};

export const trimBase64ImgUrl = (url: string) => {
    return url?.substring(22)
}


export const checkFileType = (url: string) => {
    // Define the regular expression to match '.png' or '.pdf' anywhere in the URL
    const fileTypeRegex = /\.(pdf)/i;

    // Test if the URL matches the regular expression
    return fileTypeRegex.test(url);
}